import React from 'react';
import { Link } from 'react-router-dom';
import NewsImage from './NewsImage';
import '../styles/NewsRowList.css';

const getNewsSection = (news) => (
  Array.isArray(news.sections) && news.sections.length > 0
    ? news.sections[0]
    : news.section || news.category
);

const NewsRowList = ({
  news,
  startIndex = 0,
  onNewsClick,
  firstImageEager = false,
  headingLevel = 3,
}) => {
  const Heading = `h${headingLevel}`;

  return (
    <div className="news-row-list">
      {news.map((item, index) => (
        <article className="news-row" key={item.id}>
          <Link
            to={`/news/${item.id}`}
            className="news-row__link"
            onClick={onNewsClick
              ? () => onNewsClick(item, startIndex + index)
              : undefined}
          >
            <NewsImage
              news={item}
              alt={item.title}
              className="news-row__image"
              loading={firstImageEager && index === 0 ? 'eager' : 'lazy'}
            />

            <div className="news-row__content">
              <Heading className="news-row__title">{item.title}</Heading>

              <div className="news-row__meta">
                <span>
                  {item.day}.{item.month}.{item.year}
                  {item.time ? `, ${item.time}` : ''}
                </span>

                {getNewsSection(item) && (
                  <span className="news-row__section">
                    {getNewsSection(item)}
                  </span>
                )}
              </div>
            </div>
          </Link>
        </article>
      ))}
    </div>
  );
};

export default NewsRowList;
